
















import Vue from 'vue';
import Rating from '@/components/Rating.vue';
import FemaleAvatarSVG from '@/components/svg/FemaleAvatarSVG.vue';

export default Vue.extend({
  props: {
    reviewerName: String,
    rating: Number,
    comments: String,
    createdAt: String,
    updatedAt: String,
  },
  components: {
    Rating,
    FemaleAvatarSVG,
  },
});
